module.exports = __webpack_public_path__ + "img/content2.99d48537.jpg";